import type { FC } from 'react';

import { useEntrar } from '../../../../logica/auth/useEntrar';
import { useEntrarComProvedor } from '../../../../logica/auth/useEntrarComProvedor';
import { CodigoDoEmailLigado } from '../CodigoDoEmailLigado';
import { Entrar } from './Entrar';

// /login — liga a lógica (src/logica/auth) à tela.
const EntrarLigado: FC = () => {
  const entrar = useEntrar();
  const provedores = useEntrarComProvedor();
  return (
    <Entrar
      {...entrar}
      provedores={provedores}
      codigo={<CodigoDoEmailLigado email={entrar.email.trim()} aoConfirmar={entrar.aoConfirmar} reenviarAoAbrir />}
    />
  );
};

export default EntrarLigado;
